import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {LoginGuard} from 'guards/login.guard';
import {TipListDetailsComponent} from './tip-list-details.component';

const routes: Routes = [
  {path: 'tiplist/details', component: TipListDetailsComponent, canActivate: [LoginGuard]},
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [
    RouterModule,
  ],
})

export class TipListDetailsRoutingModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/tip-list/tip-list-details/tip-list-details-routing.module.ts